import _ from "underscore";
import DriveView from "../../DriveView";
import Sync from "../../sync/sync";
import { PageLevel } from "../../store/mobile/types";
import pageHTML from "./event.tmpl";
import Messages from "../../model/Messages";
import { locationLinkClick, messageLinkClick } from "../messaging/helpers";
import { getServerDate } from "../../utils/storage/date";
import Message from "../../model/Message";

export default class EventView extends DriveView<any> {
    private readonly template = _.template(pageHTML);
    private readonly sync: Sync;
    private readonly message: Message | undefined;
    private readonly currentUserId: string | undefined;

    constructor (options) {
        super(options, {
            title: "Event",
            activeSection: "notifications",
            activeView: "inbox",
            pageLevel: PageLevel.TWO
        });

        let currentUser = this.app.userService.getCurrentUser();
        if (currentUser) {
            this.currentUserId = currentUser.id;
        }
        this.sync = this.app.sync;
        let messages = new Messages(this.app.store, currentUser?.id);
        messages.fetch();
        this.message = messages.getMessages(undefined).find((msg) => msg.id === options.state.messageId);
        this.render();
    }

    /* eslint-disable @typescript-eslint/unbound-method */
    events() {
        return {
            "click .locationLink": locationLinkClick,
            "click .messageLink": messageLinkClick
        } as Backbone.EventsHash;
    }
    /* eslint-enable @typescript-eslint/unbound-method */

    render () {
        this.display(this.template({
            message: this.message
        }));

        this.markMessageAsRead();
        return this;
    }

    markMessageAsRead() {
        if (this.message && this.message.delivered && !this.message.read && this.currentUserId) {
            this.message.read = getServerDate().toISOString();
            this.message.markedReadBy = { id: this.currentUserId };
            void this.sync.messages.setItem(this.message, true);
        }
    }
}
